import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Async thunk for posting SEO information (create)
export const createProductSeo = createAsyncThunk(
  'seo/createProductSeo',
  async (seoData, { rejectWithValue }) => {
    try {
      const response = await axios.post('/api/createseo', seoData);
      return response.data;
    } catch (error) {
      console.error('Error creating SEO information:', error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Async thunk for fetching SEO information by ex_product_id
export const fetchSeoByProductId = createAsyncThunk(
  'seo/fetchSeoByProductId',
  async (ex_product_id, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/api/getseo/${ex_product_id}`);
      console.log('form seo slice',response.data)
      return response.data;
      
    } catch (error) {
      console.error('Error fetching SEO information:', error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Async thunk for updating SEO information by ex_product_id
export const updateProductSeo = createAsyncThunk(
  'seo/updateProductSeo',
  async ({ ex_product_id, seoData }, { rejectWithValue }) => {
    try {
      const response = await axios.put(`/api/updateseo/${ex_product_id}`, seoData);
      return response.data;
    } catch (error) {
      console.error('Error updating SEO information:', error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const seoSlice = createSlice({
  name: 'seo',
  initialState: {
    seoInfo: null,
    loading: false,
    error: null,
    success: false,
    isFetched: false,
  },
  reducers: {
    clearSeoState: (state) => {
      state.seoInfo = null;
      state.loading = false;
      state.error = null;
      state.success = false;
      state.isFetched = false;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch SEO
      .addCase(fetchSeoByProductId.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.isFetched = false;
      })
      .addCase(fetchSeoByProductId.fulfilled, (state, action) => {
        state.loading = false;
        state.seoInfo = action.payload;
        const isNotEmpty =
          action.payload.seo && Object.keys(action.payload.seo).length > 0;
        state.isFetched = isNotEmpty;
      })
      .addCase(fetchSeoByProductId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.isFetched = false;
      })

      // Create SEO
      .addCase(createProductSeo.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(createProductSeo.fulfilled, (state, action) => {
        state.loading = false;
        state.seoInfo = action.payload;
        state.success = true;
        state.error = null;
      })
      .addCase(createProductSeo.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      })

      // Update SEO
      .addCase(updateProductSeo.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(updateProductSeo.fulfilled, (state, action) => {
        state.loading = false;
        state.seoInfo = action.payload;
        state.success = true;
        state.error = null;
      })
      .addCase(updateProductSeo.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      });
  },
});

// Export actions and reducer
export const { clearSeoState } = seoSlice.actions;
export default seoSlice.reducer;
